/**
 * 选品配置的通用 DOM 操作。
 *
 * 统一使用 DOM API 与 textContent，避免将接口数据拼接为 HTML 字符串。
 */
export function createConfigElement(tagName, className = '', text = undefined) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== undefined && text !== null) element.textContent = String(text);
  return element;
}

export function replaceConfigChildren(element, ...children) {
  if (element) element.replaceChildren(...children);
  return element;
}

export function appendConfigText(element, text) {
  element?.append(document.createTextNode(String(text ?? '')));
  return element;
}

export const createConfigStatus = (className, text) => createConfigElement('span', className, text);
export const createConfigEmptyStatus = createConfigStatus;

export function setConfigText(id, text) {
  const element = document.getElementById(id);
  if (element) element.textContent = text;
}

export function setConfigValue(id, value) {
  const element = document.getElementById(id);
  if (element && value != null) element.value = value;
}

export function padConfigNumber(n) {
  return String(n ?? 0).padStart(2, '0');
}

export function setConfigFeedback(id, message, type) {
  const element = document.getElementById(id);
  if (!element) return;
  element.classList.remove('pr-config-feedback--success', 'pr-config-feedback--error', 'pr-config-feedback--info');
  element.classList.add('pr-config-feedback');
  if (type === 'success' || type === 'error' || type === 'info') {
    element.classList.add(`pr-config-feedback--${type}`);
  }
  element.textContent = message;
}

export function setConfigButtonLoading(id, loading) {
  const button = document.getElementById(id);
  if (!button) return;
  button.disabled = loading;
  if (loading) {
    button.dataset.originalText = button.textContent;
    button.textContent = '处理中…';
  } else if (button.dataset.originalText) {
    button.textContent = button.dataset.originalText;
  }
}

export function formatConfigTime(value) {
  if (!value) return '-';
  try {
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' });
  } catch {
    return String(value);
  }
}
